// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__207vP","colMin":"styles_colMin__3Kom-"};